<template>
  <span :class="badgeClasses" :style="badgeStyle">{{ displayText }}</span>
</template>

<script>
var STATUS_CONFIG = {
  Unallocated: {
    label: 'Unallocated',
    bg: 'rgba(108, 117, 125, 0.14)',
    color: '#495057'
  },
  PartiallyAllocated: {
    label: 'Partially Allocated',
    bg: 'rgba(255, 168, 0, 0.18)',
    color: '#c87000'
  },
  Allocated: {
    label: 'Allocated',
    bg: 'rgba(40, 167, 69, 0.15)',
    color: '#1e7e34'
  }
}

var FALLBACK = {
  label: null,
  bg: 'rgba(108, 117, 125, 0.14)',
  color: '#495057'
}

export default {
  name: 'StatusCell',

  props: {
    value: {
      type: String,
      required: true
    }
  },

  computed: {
    config: function () {
      return STATUS_CONFIG[this.value] || FALLBACK
    },

    displayText: function () {
      return this.config.label || this.value
    },

    badgeClasses: function () {
      return ['badge', 'badge-pill', 'status-cell-badge']
    },

    badgeStyle: function () {
      return {
        backgroundColor: this.config.bg,
        color: this.config.color
      }
    }
  }
}
</script>

<style scoped>
.status-cell-badge {
  font-size: 0.82rem;
  font-weight: 500;
  padding: 0.35em 0.85em;
  border: none;
  white-space: nowrap;
}
</style>
